/**
 * Created by: cparaschiv
 * Date: 27.05.2013, 18:23
 */

TS.ns('TS.domain.properties');

/**
 * @class TS.domain.properties.DomainProperty
 * @classdesc
 * @extends TS.Observable
 * @ignore
 */
TS.domain.properties.DomainProperty = new Class(
    /** @lends TS.domain.properties.DomainProperty # */
    {

        Extends: TS.Observable,

        defaults: {},

        mapping: {
            ignore: ['Value'],
            copy: ['Name', 'propertyType'],
            suppress: ['Name', 'propertyType', 'EditMember']
        },

        //region Constructor

        initialize: function (domain, config) {
            var me = this;
            me.config = config;

            $.extend(true, me, me.defaults);
            Object.append(me, ko.mapping.fromJS(config, this.getMappingOptions()));

            me.parent();
            me.Domain(domain);
            me.afterInitialization.apply(me, arguments);
        },

        afterInitialization: function () {
        },

        getMappingOptions: function () {
            return this.mapping;
        },

        //endregion

        //region Properties

        //region Domain

        _Domain: null,

        Domain: function (value) {
            if (arguments.length === 0)
                return this._Domain;
            if (this._Domain !== value) {
                this._Domain && this.unhookDomain();
                this._Domain = value;
                this._Domain && this.hookDomain();
            }
        },

        hookDomain: function () {
            var me = this,
                editMember = me.EditMember();
            setTimeout(function () {
                editMember && me.onValueChanged && (me._valueAccessor = me.watch(editMember, me.Domain(), me.onValueChanged.bind(me)));
            });
        },

        unhookDomain: function () {
            var me = this;
            if (me._valueAccessor) {
                me._valueAccessor.dispose();
                var idx = me._accessors.indexOf(me._valueAccessor);
                if (idx > -1) {
                    me._accessors.splice(idx, 1);
                }
                delete me._valueAccessor;
            }
        },

        //endregion

        //region Value

        Value: function (value) {
            if (arguments.length === 0)
                return this.getValue();
            return this.setValue(value);
        },

        getValue: function () {
            var me = this,
                domain = me.Domain(),
                editMember = ko.valueOf(me.EditMember);
            if (ts.hasValue(domain) && ts.hasValue(editMember)) {
                var result = ts.getPropertyValue(domain, editMember);
                if (TS.isObject(result) && 'Value' in result) {
                    return result.Value();
                }
                return result;
            }
            return null;
        },

        setValue: function (value) {
            var me = this,
                domain = me.Domain(),
                editMember = ko.valueOf(me.EditMember);
            if (ts.hasValue(domain) && ts.hasValue(editMember)) {
                var editValue = ts.getPropertyValue(domain, editMember);
                if (TS.isObject(editValue) && 'Value' in editValue) {
                    editValue.Value(value);
                    return;
                }
                ts.setPropertyValue(domain, editMember, value);
            }
        },

        //endregion

        //endregion

        //region (Get)SetData
        /**
         * Returns an object containing values to be posted to server.
         * @protected
         */
        _getData: function () {
            var me = this,
                result = ko.mapping.toJS(me);

            $.each(me.mapping.suppress, function (idx, prop) {
                delete result[prop];
            });

            return result;
        },

        /**
         * Updates the property from the server response.
         * @method
         * @param {Object} config
         * @protected
         */
        _setData: function (data) {
            var me = this;
            ko.mapping.fromJS(data, me);
        },

        //endregion

        //region Dispose

        dispose: function () {
            var me = this;
            me.unhookDomain();
            me.parent();
        },

        //endregion

    });

/*legacy*/
TS.domain.properties.DomainProperty.prototype.getPostData = TS.domain.properties.DomainProperty.prototype._getData;
TS.domain.properties.DomainProperty.prototype._update = TS.domain.properties.DomainProperty.prototype._setData;
TS.domain.properties.DomainProperty.prototype.hookViewModel = TS.domain.properties.DomainProperty.prototype.hookDomain;
TS.domain.properties.DomainProperty.prototype._beforeConvert = $.noop;
TS.domain.properties.DomainProperty.prototype._afterConvert = $.noop;
TS.domain.properties.DomainProperty.prototype._afterBind = $.noop;

TS.ObjectFactory.map('DomainProperty', TS.domain.properties.DomainProperty);

/**
 * Gets a reference to the view model that owns this property.
 * @returns {Object}
 * @public
 */
TS.domain.properties.DomainProperty.prototype._getOwner = function () {
    return this.Domain();
};
